const dotenv = {
  production: {
    BASE_API_URL: "https://api.innosapp.com.ar/api/v1",
    DEBUG_MODE: false,
    ONESIGNAL_APPID: 'x',
    ONESIGNAL_SAFARI_WEB_ID: 'web.onesignal.auto.x',
    GOOGLE_CLIENT_ID: 'x.apps.googleusercontent.com',
    FACEBOOK_APP_ID: 'x',
    OPENTOK_API_ID: '47383111',
    DOMAIN_NAME: 'https://app.innos.com.ar',
    MP_PUBLIC_KEY: "APP_USR-462cc048-760f-4ac6-a925-e987c1c200c1",
    MP_CLIENT_ID: "2287994415510929",
  },

  development: {
    BASE_API_URL: "http://api.innosapp.com.ar/api/v1",
    DEBUG_MODE: true,
    ONESIGNAL_APPID: 'x',
    ONESIGNAL_SAFARI_WEB_ID: 'x',
    GOOGLE_CLIENT_ID: 'x.googleusercontent.com',
    FACEBOOK_APP_ID: 'x',
    OPENTOK_API_ID: '47383111',
    DOMAIN_NAME: 'http://localhost:3000',
    MP_PUBLIC_KEY: "APP_USR-462cc048-760f-4ac6-a925-e987c1c200c1",
    MP_CLIENT_ID: "2287994415510929",
  }
}

const vars = {

  VERSION: 'v20210517.001',
  CLIENT_ID: '11111111111',
  CLIENT_SECRET: 'qwetqutuqwteutuqwteuqwtuetqwyteuqt',
  
};

const { NODE_ENV } = process.env;
const dotenvVars = Object.assign(
  ...Object.keys(dotenv[NODE_ENV])
    .map( key => ({ [key]: dotenv[NODE_ENV][key] }) )
);
const general = { ...vars, ...dotenvVars };
export default general;